/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/thoughtful/twenty-fun.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/thoughtful/twenty-fun.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/twenty-fun.mdx';

const metadata = {
  slug: "twenty-fun",
  title: "Twenty Fun",
  author: "Christian Battaglia",
  description: "21 weeks in the best city in the world at 24 years old. Lessons on listening before leaping, finding quiet in the chaos, under-promising and over-delivering, and a simple mental model for happiness that actually works.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris-profile-hat.jpg",
  headerImage: "/assets-cdbattaglia/media/blog-posts/2018-06-11_twenty-fun/skyline-from-ave-c.webp",
  date: "2018-06-11T00:00:00.000Z",
  
  readTime: "7 min read",
  tags: ["NYC","life lessons","personal growth","Amplify","career","Alphabet City","happiness","community"],
};

export const Route = createFileRoute('/blog/posts/twenty-fun')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/twenty-fun',
    image: '/og/blog/twenty-fun.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
